import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'

export type PartnerStatusMode = 'termination' | 'former'

export type PartnerStatusCandidate = {
  partner_number: number
  persons_fio: string
  current_status: string | null
  status_changed_at: string | null
  active_studio_count: number
  cities_text: string
}

export type PartnerStatusHistoryRow = {
  section: 'Текущий статус' | 'История'
  partner_number: number
  status: string | null
  changed_at: string | null
  old_status: string | null
  changed_by: string | null
}

export type SetPartnerStatusResult = {
  target_partner_numbers: number[]
  target_partner_status: 'на расторжении' | 'бывший'
  v_my_ts: string
  updated_count: number
}

export async function fetchPartnerStatusCandidates(): Promise<PartnerStatusCandidate[]> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('list_partner_status_candidates')
  )) as { data: PartnerStatusCandidate[] | null; error: any }

  if (error) throw error
  return data ?? []
}

export async function fetchPartnerStatusContext(partnerNumber: number): Promise<PartnerStatusHistoryRow[]> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('get_partner_status_context', {
      p_partner_number: partnerNumber,
    })
  )) as { data: PartnerStatusHistoryRow[] | null; error: any }

  if (error) throw error
  return data ?? []
}

export async function setPartnerStatus(params: {
  mode: PartnerStatusMode
  targetPartnerNumbers: number[]
  changedAt: string
}): Promise<SetPartnerStatusResult> {
  const rpcName = params.mode === 'termination'
    ? 'set_partner_status_termination'
    : 'set_partner_status_former'

  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc(rpcName, {
      target_partner_numbers: params.targetPartnerNumbers,
      v_my_ts: params.changedAt,
    })
  )) as { data: SetPartnerStatusResult | null; error: any }

  if (error) throw error
  if (!data) throw new Error('Статус франчайзи не изменен')
  return data
}
